import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CreateCvSectionGalleryRequest,
  CvSectionGallery,
  CvSectionGalleryResponse,
} from '@/../gen';

export const namespace = 'cvSectionGalleryNew';
const actionCreator = actionCreatorFactory(namespace);

export const SetCvSectionGallery = actionCreator<CvSectionGalleryResponse>(
  'SET_CV_SECTION_GALLERY'
);
export const CreateCvSectionGallery = actionCreator<{
  params: {
    cv_id: number;
  };
  body: CreateCvSectionGalleryRequest;
}>('CREATE_CV_SECTION_GALLERY');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionGallery: CvSectionGallery;
}

const initialState = (): State => {
  return { cvSectionGallery: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(CreateCvSectionGallery, async function(context, action) {
      const { data } = await this.proffApi.createCvSectionGallery(
        action.payload.params.cv_id,
        action.payload.body
      );
      context.commit(SetCvSectionGallery(data.data));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionGallery, (state, action) => {
      state.cvSectionGallery = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionGallery: state => state.cvSectionGallery,
  },
};
